import {fetchFromApi, getBackendApiURL} from "../../../BackendFacade";
import {IValueContainer} from "../../../Utils/IValueContainer";
import {IAppConfig} from "../Interfaces/IConfig";
import {IIdmsUserUpdateBody} from "../Interfaces/IUsers";

export function getConfigDataCall(projectId: string, moduleInstanceId: string) {
    const url = getBackendApiURL() + "projects/" + projectId + "/modules/" + moduleInstanceId + "/config";
    return fetchFromApi(url, "GET")
}

export function sendConfigEditDataCall(projectId: string, moduleInstanceId: string, value: IValueContainer<IAppConfig>) {
    const url = getBackendApiURL() + "projects/" + projectId + "/modules/" + moduleInstanceId + "/config";
    return fetchFromApi(url, "POST", value)
}

export function getUserDataCall(projectId: string, moduleInstanceId: string) {
    const url = getBackendApiURL() + "projects/" + projectId + "/modules/" + moduleInstanceId + "/user";
    return fetchFromApi(url, "GET")
}

export function sendUsersEditDataCall(projectId: string, moduleInstanceId: string, body: IValueContainer<IIdmsUserUpdateBody[]>) {
    const url = getBackendApiURL() + "projects/" + projectId + "/modules/" + moduleInstanceId + "/user";
    return fetchFromApi(url, "POST", body); // INFO: body is {value:[{id:"", newValue:"{}"}]}
}
